import { axiosInstance } from "@/api/apiClient";
import {
  SubscriptionApi,
  SubscriptionApiPaymentsViewsNinjaSubscriptionClearPendingInvoiceRequest,
  SubscriptionApiPaymentsViewsNinjaSubscriptionGetBusinessSubscriptionRequest,
  SubscriptionApiPaymentsViewsNinjaSubscriptionGetInvoiceRequest,
  SubscriptionApiPaymentsViewsNinjaSubscriptionGetSubscriptionStatusRequest,
} from "@/api/client";
import { CustomAxiosRequestConfig } from "@/api/types";
import { BASE_API } from "@/helpers/constants";
import { AxiosResponse } from "axios";

const api = new SubscriptionApi(undefined, BASE_API, axiosInstance);

export const getBusinessSubscription = async (
  payload: SubscriptionApiPaymentsViewsNinjaSubscriptionGetBusinessSubscriptionRequest
) => {
  return api.paymentsViewsNinjaSubscriptionGetBusinessSubscription.bind(api)(
    payload
  );
};

export const getSubscriptionInvoice = async (
  payload: SubscriptionApiPaymentsViewsNinjaSubscriptionGetInvoiceRequest
) => {
  return api.paymentsViewsNinjaSubscriptionGetInvoice.bind(api)(payload, {
    accessLevel: "public",
  } as CustomAxiosRequestConfig);
};

export const clearPendingInvoice = async (
  payload: SubscriptionApiPaymentsViewsNinjaSubscriptionClearPendingInvoiceRequest
) => {
  return api.paymentsViewsNinjaSubscriptionClearPendingInvoice.bind(api)(
    payload,
    { accessLevel: "public" } as CustomAxiosRequestConfig
  );
};

export type SubscriptionStatusResponse = {
  message: null;
  success: true;
  data: { status: string };
};

export const getSubscriptionStatus = async (
  payload: SubscriptionApiPaymentsViewsNinjaSubscriptionGetSubscriptionStatusRequest
) => {
  return api.paymentsViewsNinjaSubscriptionGetSubscriptionStatus.bind(api)(
    payload
  ) as Promise<AxiosResponse<SubscriptionStatusResponse>>;
};
